"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItem = exports.TEST_ID_LIST_ITEM = void 0;
/** @jsxRuntime classic */
/** @jsx jsx */
var react_1 = require("react");
var theme_ui_1 = require("theme-ui");
var theme_1 = require("../../../theme");
var IconLink_1 = require("../../atoms/IconLink/IconLink");
exports.TEST_ID_LIST_ITEM = "list-item";
var ListItem = function (_a) {
    var onClick = _a.onClick, href = _a.href, beforeIcon = _a.beforeIcon, beforeIconCsx = _a.beforeIconCsx, caption = _a.caption, csx = _a.csx;
    var commonStyles = react_1.useMemo(function () { return ({
        paddingLeft: theme_1.theme.space[3] + "px",
        "::before": __assign({ background: theme_1.theme.colors.grey010, content: "''", display: beforeIcon ? "inline-block" : "none", position: "relative", mask: "no-repeat center", maskSize: "contain", height: 2, width: 2, maskImage: beforeIcon ? "url(" + beforeIcon + ")" : "none", mr: 2 }, beforeIconCsx)
    }); }, [beforeIconCsx, beforeIcon]);
    return (theme_ui_1.jsx("li", { "data-testid": exports.TEST_ID_LIST_ITEM, onClick: onClick, sx: __assign({ variant: "text.li", cursor: "pointer", ":hover": {
                filter: "brightness(1.3)",
            } }, csx) }, href
        ? theme_ui_1.jsx(IconLink_1.IconLink, { href: href, csx: __assign({ textDecoration: "none", display: "block", py: 0 }, commonStyles) }, caption)
        : theme_ui_1.jsx("div", { sx: commonStyles }, caption)));
};
exports.ListItem = ListItem;
